import React from 'react';

import './TeleconsultingPage.css';
import { TeleconsultingTab } from './components/TeleconsultingTab';

export function TeleconsultingPage() {
  return (
    <>
      <div className="headerTeleconsultingPage">
        <h1 className="pageTitle">Teleatendimentos</h1>
      </div>
      <TeleconsultingTab />
    </>
  );
}
